import VisaIcon from '../assets/visa.svg'
import MastercardIcon from '../assets/mastercard.svg'
import AmericanExpressIcon from '../assets/amex.svg'
import UnionPayIcon from '../assets/unionpay.svg'
import DiscoverIcon from '../assets/discover.svg'

export const detectCardBrand = firstSixDigits => {
  switch (true) {
    case /^4/.test(firstSixDigits):
      return { src: VisaIcon, label: 'VISA' }
    case /^5[1-5]/.test(firstSixDigits):
      return { src: MastercardIcon, label: 'Mastercard' }
    case /^(34|37)/.test(firstSixDigits):
      return { src: AmericanExpressIcon, label: 'American Express' }
    case /^62/.test(firstSixDigits):
      return { src: UnionPayIcon, label: 'UnionPay' }
    case /^6/.test(firstSixDigits):
      return { src: DiscoverIcon, label: 'Discover' }
    default:
      return { src: null, label: null }
  }
}
